module.exports = __webpack_public_path__ + "images/stickers/star@2x.8aaf5c9e688f80b40366.png";